import { StatusBar } from '../../cdl/StatusBar/StatusBar';
import { translate } from '../../common/helpers/translate.helper';
import { IconClock } from '../../common/icons/cdl/Clock';
import { OverlayHeader } from '../../common/Overlay/OverlayHeader';

import { ApprovalRequestContentContainer } from './ApprovalRequestContentContainer';

const GeneralErrorStatusBar = () => {
    const headline = translate('approvalRequest.statusBar.generalError.headline');
    const subHeadline = translate('approvalRequest.statusBar.generalError.subHeadline');

    return <StatusBar variant="negative" headline={headline} subHeadline={subHeadline} leadingVisual={<IconClock />} />;
};

export const GeneralError = () => {
    return (
        <OverlayHeader>
            <ApprovalRequestContentContainer>
                <GeneralErrorStatusBar />
            </ApprovalRequestContentContainer>
        </OverlayHeader>
    );
};
